interface DeceasedUserData {
  firstName?: string;
  displayName?: string;
  surName?: string;
}

export function getRelationshipLabel(
  contactFullName: string | undefined,
  deceasedUserData: DeceasedUserData | null | undefined,
  isMeContact?: boolean,
) {
  const contactFirstName = contactFullName?.trim().split(/\s+/)[0];
  const decedentName = deceasedUserData?.displayName;

  if (isMeContact) {
    return `I am ${decedentName || "their"}'s...`;
  }

  return contactFirstName
    ? `${contactFirstName} is ${decedentName || "their"}'s...`
    : `Relationship to ${decedentName || "decedent"}`;
}

export function getDeceasedFirstName(deceasedUserData: DeceasedUserData | null | undefined) {
  return deceasedUserData?.firstName || deceasedUserData?.displayName;
}
